module.exports = __webpack_public_path__ + "static/media/logo-bancontact.d8e262f4.svg";